import React from 'react';
import "./footer.css";

function Footer() {
  return (
    <div className='footer'>
       © 2022 copyright all right reserved
    </div>
  )
}

export default Footer
